// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___Hzdq","title":"styles_title__Jy3CP","terms":"styles_terms__dYcQ6"};